<template>
  <div></div>
</template>

<script lang='ts'>
import {
  Component, Prop, Vue
} from 'vue-property-decorator';
import KeyValue from '@/models/KeyValue';
import ExtraData from '@/models/ExtraData';

@Component
export default class ExtraDataComponent extends Vue {
  @Prop({
    default: () => []
  })
  public extraDataValues!: KeyValue[];

  public created() {
    if (this.extraDataValues) {
      this.extraDataValues.forEach((extraData) => {
        this.$store.dispatch('enquiryModule/submitExtraData', new ExtraData(extraData.key, extraData.value));
      });
    }
  }
}
</script>
